// @import dependencies
import React, { CSSProperties, useState, useEffect } from 'react'
// @end dependencies

// @import components
import GraphcardCommon from 'app_components/commons/graphcard'
// @end components

// @import types
// @end types

// @import services
import CourseSchedulingService from 'app_services/admin/courseScheduling/courseSchedulingService'
// @end services

// @import hooks
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './StatsSchedulingModule.scss'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import CertificateService from 'app_services/user/certificateService'
// @end styles

interface IStatsSchedulingModuleProps {
  className?: string
  style?: CSSProperties
  id?: string

}

interface StatSchedulingConfirmed{
  date_ms: number;
  courses: number;
  dateFormated: string;
}

interface StatCertificateGenerated{
  date_ms: number;
  certificates: number;
  dateFormated: string;
}

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false
    }
  },
  scale: {
    ticks: {
      precision: 0
    }
  }
}

const StatsSchedulingModule: React.FC<IStatsSchedulingModuleProps> = (props) => {

  const [statsScheduling, updateStatsScheduling] = useState<StatSchedulingConfirmed[]>([]);
  const [statsCertificates, updateStatsCertificates] = useState<StatCertificateGenerated[]>([]);
  const [coursesWithoutDate, updateCoursesWithoutDate] = useState<number>(0);

  const courseSchedulingService = new CourseSchedulingService();
  const certificateService = new CertificateService();

  useEffect(() => {
    getServicesByMonth();
    getCertificatesByMonth();
  }, [])

  const getServicesByMonth = async () => {
    const response: any = await courseSchedulingService.schedulingConfirmedByMonth();
    if (response?.code === 200) {
      if (response?.coursesConfirmed?.length) {
        updateStatsScheduling(response?.coursesConfirmed);
      }
      updateCoursesWithoutDate(response?.coursesWithoutDate ? response?.coursesWithoutDate : 0);
    }
  }

  const getCertificatesByMonth = async () => {
    const response: any = await certificateService.certificateGeneratedByMonth();
    if (response?.code === 200) {
      if (response?.certificatesGenerated?.length) {
        updateStatsCertificates(response?.certificatesGenerated);
      }
    }
  }

  return(
    <div
      className={`stats_scheduling_module-layout ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      <TextComponent
        type='subtitle'
        className='title-module'
      >
        Estadísticas
      </TextComponent>
      {coursesWithoutDate ?
      <TextComponent
        type='text'
      >
        <>
          <strong>Programas vigentes confirmados sin fecha: </strong> {coursesWithoutDate}
        </>
      </TextComponent>
      :null}
      <div className="container-charts-stats">
        <div className="chart-stat-item">
          <TextComponent
            type='text'
            className='title-chart-stat'
          >
            Programas vigentes confirmados por mes
          </TextComponent>
          <GraphcardCommon
              type='bars'
              data={{
                labels: statsScheduling.map((s) => s.dateFormated),
                datasets: [{
                  label: 'Servicios confirmados por mes',
                  data: statsScheduling.map((s) => s.courses),
                  backgroundColor: '#005078'
                }]
              }}
              options={chartOptions}
            />
        </div>
        <div className="chart-stat-item">
          <TextComponent
            type='text'
            className='title-chart-stat'
          >
            Participantes capacitados por mes
          </TextComponent>
          <GraphcardCommon
              type='bars'
              data={{
                labels: statsCertificates.map((s) => s.dateFormated),
                datasets: [{
                  label: 'Participantes capacitados por mes',
                  data: statsCertificates.map((s) => s.certificates),
                  backgroundColor: '#005078'
                }]
              }}
              options={chartOptions}
            />
        </div>
      </div>
    </div>
  );
}

export default StatsSchedulingModule;
